"use client"

import styled from "@emotion/styled"
import { replaceRichTextLinks } from "utils"

const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  padding-block: 40px;
  gap: 24px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 40px;
  }
`

const StyledTitle = styled.h2`
  margin: 0;
  font-size: 28px;
  font-weight: 400;
  line-height: 1.25;
  letter-spacing: -0.8px;
  text-transform: capitalize;
  width: 100%;

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 40px;
  }
`

const StyledTitleBlue = styled.span`
  color: #0000fa;
`

const StyledTitleBlack = styled.span`
  color: ${({ theme }) => theme.colors.port.defaultTextColor};
`

const StyledText = styled.div`
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.port.defaultTextColor};
  width: 100%;

  p {
    margin: 0;
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 18px;
  }

  * {
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
`

type CancellationPolicyProps = {
  blueTitle: string
  blackTitle: string
  text: string
}

export default function CancellationPolicy({
  blueTitle,
  blackTitle,
  text,
}: CancellationPolicyProps) {
  if (!text) return null

  return (
    <StyledSection>
      <StyledTitle>
        <StyledTitleBlue>{blueTitle}</StyledTitleBlue>
        {blackTitle && (
          <>
            {" "}
            <StyledTitleBlack>{blackTitle}</StyledTitleBlack>
          </>
        )}
      </StyledTitle>
      <StyledText dangerouslySetInnerHTML={{ __html: replaceRichTextLinks(text) }} />
    </StyledSection>
  )
}
